var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.355 5.284a.75.75 0 01-.002 1.042l-4.077 4.207H21.25a.75.75 0 01.75.75v1.447a.75.75 0 01-.75.75H7.277l4.076 4.207a.75.75 0 01.002 1.042l-1.027 1.066a.75.75 0 01-1.08.001l-7.03-7.268a.75.75 0 010-1.043l7.03-7.269a.75.75 0 011.08.001l1.027 1.067z",
    fill: "#D4DAE0"
  })));
}
export default SvgIconBack;